import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlacementsStudentsPlacedListComponent } from './placements-students-placed-list/placements-students-placed-list.component';
import { PlacementsStudentsPlacedCreateComponent } from './placements-students-placed-create/placements-students-placed-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: PlacementsStudentsPlacedListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: PlacementsStudentsPlacedCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'studentsplaced-create/:id',
        component: PlacementsStudentsPlacedCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentsPlacedRoutingModule { }
